import * as R from 'ramda';
import { Form, message } from 'antd';
import { connect } from 'react-redux';
import { withProps, withState, withHandlers } from 'recompose';

import { debounceTime } from '../constants';
import { closeCurrentModal } from '../../modals';
import { fetchCompanies } from '../../api/apiko-api';
import { getContactById } from '../../redux/selectors';
import ContactForm from '../../components/contact-form';
import { handleContactUpdate } from '../../redux/thunk/contacts';
import { updateContactFailure } from '../../redux/actions/contacts';

import {
  debounce,
  addNewField,
  removeField,
  getResErrorMsg,
  deleteFalseElements,
} from '../../utils';


const debouncedFetch = debounce(fetchCompanies, debounceTime);

const mapStateToProps = (state, { payload }) => {
  const { contacts: { isUpdating } } = state;

  return ({
    isLoading: isUpdating,
    contact: getContactById(state, payload),
  });
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeCurrentModal()),
  failedToUpdateContactAction: () => dispatch(updateContactFailure()),
  handleContactUpdate: (_id, data) => dispatch(handleContactUpdate(_id, data)),
});

export const EditContactModal = Form.create()(R.compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps({ title: 'Edit Contact' }),
  withState('isFetchingCompanies', 'setIsFetchingCompanies', false),
  withState('companiesList', 'setCompaniesList', ({ contact }) => contact.company && !R.isNil(contact.company) ? [contact.company] : []),
  withState('emailFieldId', 'updateEmailFieldId', ({ contact }) => contact.emails && !R.isEmpty(contact.emails) ? contact.emails.length : 1),
  withState('phoneFieldId', 'updatePhoneFieldId', ({ contact }) => contact.phones && !R.isEmpty(contact.phones) ? contact.phones.length : 1),
  withHandlers({
    onSubmitForm: ({
      title,
      form,
      contact,
      ...actions
    }) => (event) => {
      event.preventDefault();
      form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const object = R.omit(['emailKeys', 'phoneKeys'], values);
          object.emails = deleteFalseElements([...new Set(object.emails)]);
          object.phones = deleteFalseElements([...new Set(object.phones)]);
          object.country = object.country || null;

          actions.handleContactUpdate(contact._id, object)
            .then(() => {
              actions.closeModal();
              message.success('Contact successfully updated');
            })
            .catch((error) => {
              actions.failedToUpdateContactAction();
              message.error(`${getResErrorMsg(error)}`);
            });
        } else {
          console.error(err);
        }
      });
    },

    handleCompaniesSearch: props => (value) => {
      if (value.length > 1) {
        props.setIsFetchingCompanies(true);
        debouncedFetch({ searchTerm: value, simpleList: true })
          .then(({ data }) => {
            props.setCompaniesList(data.companies);
            props.setIsFetchingCompanies(false);
          });
      } else props.setCompaniesList([]);
    },

    addEmailField: ({ form, emailFieldId, updateEmailFieldId }) => () =>
      addNewField(form, emailFieldId, updateEmailFieldId, 'emailKeys'),

    removeEmailField: ({ form }) => key =>
      removeField(form, key, 'emailKeys'),

    addPhoneField: ({ form, phoneFieldId, updatePhoneFieldId }) => () =>
      addNewField(form, phoneFieldId, updatePhoneFieldId, 'phoneKeys'),

    removePhoneField: ({ form }) => key =>
      removeField(form, key, 'phoneKeys'),
  }),
)(ContactForm));



// WEBPACK FOOTER //
// ./src/modals/edit-contact/index.js